import i18n from "i18next";
import { NAME_SPACES } from "shared/locales/constants";

export const editorText = (key, options) =>
  i18n.t(key, {
    ns: NAME_SPACES.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS_EDITOR,
    ...options,
  });

export const withLabel = (item, key, options) =>
  Object.defineProperty(item, "label", {
    enumerable: true,
    get: () => editorText(key, options),
  });
